import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import { SupplierSegmentation } from '../models/segment-parent.model';
import {
  selectIsTogglingSegmentation,
  selectIsLoadingSegmentation,
  selectIsSavingSegmentation,
  selectSegmentation,
} from './company.selectors';

@Injectable({ providedIn: 'root' })
export class CompanySegmentationSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly segmentation: Signal<Nullable<SupplierSegmentation>> =
    this._store.selectSignal(selectSegmentation);
  public readonly isLoadingSegmentation: Signal<boolean> =
    this._store.selectSignal(selectIsLoadingSegmentation);
  public readonly isSavingSegmentation: Signal<boolean> =
    this._store.selectSignal(selectIsSavingSegmentation);
  public readonly isTogglingSegmentation: Signal<boolean> =
    this._store.selectSignal(selectIsTogglingSegmentation);
}
